import { useEffect, useRef } from "react";
import { useDispatchApp, useSelectorApp } from "../lib/redux";
import {
  startListenerGlobalNotifications,
  stopListenerGlobalNotifications,
  syncGlobalNotificationsAction,
} from "../actions/globalNotifications";

export const useGlobalNotificationsListener = () => {
  const dispatch = useDispatchApp();
  const referencesRef = useRef(null);
  const uid = useSelectorApp((state) => state.auth.user?.uid);

  useEffect(() => {
    if (!uid) {
      dispatch(
        syncGlobalNotificationsAction({
          alerts: [],
          readIds: [],
          dismissedIds: [],
        })
      );
      return undefined;
    }

    dispatch(
      startListenerGlobalNotifications({
        uid,
        onReferencesAvailable: (references) => {
          referencesRef.current = references;
        },
        onUpdatedDataCallback: (notifications) => {
          dispatch(syncGlobalNotificationsAction(notifications));
        },
      })
    );

    return () => {
      dispatch(
        stopListenerGlobalNotifications({
          globalRef: referencesRef.current?.globalRef,
          userRef: referencesRef.current?.userRef,
        })
      );
      referencesRef.current = null;
    };
  }, [uid, dispatch]);
};
